import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components/Toast'

import { handlerServerError } from '@orbit/errors'

export const useUploadBatchFile = (isCTR: boolean) => {
  const router = useRouter()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (formData: FormData) =>
      isCTR
        ? Request.post(Request.urls.bank.bsaCtrUploadBatchFile, formData)
        : Request.post(Request.urls.bank.sarUploadBatchFile, formData),
    onError: (error: Error) => {
      if (!error.message) {
        Toast.errorSmall('Something went wrong...')
      } else {
        handlerServerError(error)
      }
    },
    onSuccess: async () => {
      await router.invalidate()
      await queryClient.invalidateQueries({ queryKey: ['batch'] })
    }
  })
}
